'use strict';

/**
 * @module bss/ngcomejq
 * @description Configura $httpProvider in maniera che il body della request venga inviato come da $.ajax di jQuery.
 */
var bssngcomejq = angular.module("bss.ngcomejq", [])
    .run(["$http", require("./RunNgHttpLikeJQAjax")]);
    
module.exports = bssngcomejq;